import { render } from "./AIMatchProfileAnalysisCache.vue?vue&type=template&id=2d4a0240"
import script from "./AIMatchProfileAnalysisCache.vue?vue&type=script&lang=js"
export * from "./AIMatchProfileAnalysisCache.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__